import { ExperiencePayload } from '../../../../../../../CurrentCollectionStep/BuilderV2/Types';

export function getExperienceHeaderBackgroundByType(experience: ExperiencePayload) {
  switch (experience.offering_type) {
    case 'aep':
    case 'epc':
    case 'msuite':
      return 'bg-[#F4F4F4] bg-on-demand-program-header';
    case 'group-coaching':
      return 'bg-[#F4F4F4] bg-group-coaching-program-header';
    case 'coaching':
      return 'bg-[#F4F4F4] bg-leadership-coaching-header';
    case 'program-sequence':
      return 'bg-[#F4F4F4] bg-program-sequence-header';
  }
}
